@if (deckComponent.mainLayer.cards?.length) {
    <div class="flex flex-col items-center justify-center gap-4 text-slate-600 w-[80vw] md:w-[60vw] lg:w-[20vw]">
        <div class="relative w-[80vw] h-[30vh] md:w-[60vw] md:h-[30vh] lg:w-[20vw] lg:h-[10vw]">
            <canvas baseChart [type]="'bar'" [data]="chartData" [options]="chartOptions" [legend]="false"></canvas>
        </div>
        <div class="text-center">
            Mana Curve
        </div>
        <div class="text-sm">
            Of the {{ nonlandCount}} non-land cards in the deck, the average card mana value is <span class="font-bold">{{ averageManaValue }}</span> and the median is <span class="font-bold">{{ medianManaValue }}</span>. On average, the opening hand will have <span class="font-bold">{{ landsInHand }}</span> lands.
        </div>
    </div>
}